import { motion, useReducedMotion } from "framer-motion";
import { PhoneCall, ClipboardList, Sparkles } from "lucide-react";

const STEPS = [
    {
        n: "01",
        title: "Kontakt",
        desc: "Kurz anrufen oder Formular senden – wir melden uns zeitnah zurück.",
        icon: PhoneCall,
    },
    {
        n: "02",
        title: "Besichtigung & Angebot",
        desc: "Wir verschaffen uns ein Bild und erstellen Ihnen ein faires, transparentes Angebot.",
        icon: ClipboardList,
    },
    {
        n: "03",
        title: "Reinigung & Abnahme",
        desc: "Pünktliche Ausführung, saubere Dokumentation – zuverlässig und diskret.",
        icon: Sparkles,
    },
];

export default function Process() {
    const reduce = useReducedMotion();
    return (
        <section
            id="ablauf"
            data-testid="process-section"
            className="relative py-20 sm:py-24 lg:py-28 border-t border-white/[0.06]"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl">
                    <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#7BD3FF]">
                        Ablauf
                    </p>
                    <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white">
                        In <span className="text-chrome">drei Schritten</span> sauber.
                    </h2>
                </div>

                <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-5 sm:gap-6">
                    {STEPS.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <motion.div
                                key={s.n}
                                initial={reduce ? false : { opacity: 0, y: 16 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-40px" }}
                                transition={{ duration: 0.45, delay: i * 0.06 }}
                                className="relative rounded-2xl border border-white/[0.10] bg-[rgba(18,27,42,0.55)] backdrop-blur-md p-6 card-elevated"
                                data-testid={`process-step-${s.n}`}
                            >
                                <div className="flex items-start justify-between">
                                    <span className="font-mono text-sm text-[#7BD3FF]">
                                        {s.n}
                                    </span>
                                    <div className="h-10 w-10 rounded-xl bg-[rgba(46,168,255,0.10)] border border-[rgba(46,168,255,0.25)] flex items-center justify-center">
                                        <Icon
                                            className="h-5 w-5 text-[#7BD3FF]"
                                            strokeWidth={1.6}
                                        />
                                    </div>
                                </div>
                                <h3 className="mt-6 font-heading text-xl font-semibold text-white">
                                    {s.title}
                                </h3>
                                <p className="mt-2 text-sm text-[#C9D3E1] leading-relaxed">
                                    {s.desc}
                                </p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
